<div class="blast-files">
  @if (!currentTir()) {
    <p class="blast-files__state">{{ 'GLOBAL.CHARGEMENT' | translate }}</p>
  } @else if (workflowSteps().length === 0) {
    <p class="blast-files__state">{{ 'GENERAL_TAB.NO_WORKFLOW' | translate }}</p>
  } @else {
    <div class="step-select-mobile">
      <app-select
        [options]="stepOptions()"
        [ngModel]="activeStepId()"
        (selectionChange)="onStepSelected($event)" />
    </div>

    <div class="layout">
      <nav class="rail" aria-label="Workflow steps">
        @for (etape of workflowSteps(); track etape.workflowEtapeInstanceId; let last = $last) {
          <button
            type="button"
            class="rail__step"
            [class.rail__step--active]="etape.workflowEtapeInstanceId === activeStepId()"
            [attr.data-attr]="'blast-files-step-' + etape.numeroOrdre"
            (click)="selectStep(etape)">
            <span class="rail__marker">
              <span class="rail__circle">{{ etape.numeroOrdre }}</span>
              @if (!last) {
                <span class="rail__line"></span>
              }
            </span>
            <span class="rail__label" [title]="getStepTitle(etape.nom)">{{ getStepTitle(etape.nom) }}</span>
          </button>
        }
      </nav>

      @if (activeStep(); as etape) {
        <section
          class="detail step-drag-zone"
          [class.detail--drag-over]="stepDragOver()"
          (dragenter)="onStepDragEnter($event)"
          (dragover)="onStepDragOver($event)"
          (dragleave)="onStepDragLeave($event)"
          (drop)="onStepDrop($event)">

          <header class="detail__header">
            <div class="detail__top">
              <h3 class="detail__title">{{ etape.numeroOrdre }}. {{ getStepTitle(etape.nom) }}</h3>
              <div class="detail__actions">
                <app-button
                  variant="tertiary"
                  color="amarante"
                  size="small"
                  [label]="'GENERAL_TAB.EXPORT_ALL' | translate"
                  [addIconLeft]="true"
                  data-attr="blast-files-download-all"
                  (clicked)="exportAllDocuments()">
                  <img slot="icon-left" src="assets/icon/download.svg" alt="" />
                </app-button>
                <app-button
                  variant="secondary"
                  color="amarante"
                  size="small"
                  [label]="'GENERAL_TAB.ADD_FOLDER' | translate"
                  [addIconLeft]="true"
                  data-attr="blast-files-add-folder"
                  (clicked)="openAddFolder()">
                  <img slot="icon-left" src="assets/icon/new_icon/add_circle_black.svg" alt="" />
                </app-button>
                <app-button
                  variant="secondary"
                  color="amarante"
                  size="small"
                  [label]="'GENERAL_TAB.EXPORT' | translate"
                  [addIconLeft]="true"
                  [state]="hasSelectedItems(etape.workflowEtapeInstanceId) ? 'default' : 'disabled'"
                  data-attr="blast-files-download"
                  (clicked)="exportStep()">
                  <img slot="icon-left" src="assets/icon/download.svg" alt="" />
                </app-button>
                <app-button
                  variant="primary"
                  color="amarante"
                  size="small"
                  [label]="'GENERAL_TAB.ADD_FILE' | translate"
                  [addIconLeft]="true"
                  data-attr="blast-files-add-file"
                  (clicked)="openUploadPopup()">
                  <img slot="icon-left" src="assets/icon/new_icon/add_circle.svg" alt="" />
                </app-button>
              </div>
            </div>

            <div class="detail__tags">
              <span class="tag tag--label">
                <svg class="tag__icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M6 2h12a1 1 0 0 1 1 1v18l-7-4-7 4V3a1 1 0 0 1 1-1z" fill="currentColor" />
                </svg>
                {{ getStepTitle(etape.nom) }}
              </span>
              <span class="tag tag--plain">
                <img class="tag__icon" src="assets/icon/profil-issue.svg" alt="" />
                @if (canEditPermission) {
                  <app-select
                    class="tag__select"
                    size="xsmall"
                    [options]="permissionOptions"
                    [ngModel]="etape.accessPermission"
                    [disabled]="isPermissionUpdating(etape.workflowEtapeInstanceId)"
                    (selectionChange)="onPermissionChange(etape, $event.id)" />
                } @else {
                  {{ getAccessPermission(etape) }}
                }
              </span>
              <span class="tag tag--plain" [class.tag--muted]="getTotalFilesForStep(etape) === 0">
                <img class="tag__icon" src="assets/icon/files.svg" alt="" />
                {{ getTotalFilesForStep(etape) }}
                {{ (getTotalFilesForStep(etape) > 1 ? 'GENERAL_TAB.FILES' : 'GENERAL_TAB.FILE') | translate }}
              </span>
            </div>
          </header>

          <div class="detail__body">
            @if (getFolderForStep(etape.workflowEtapeInstanceId); as dossier) {
              @if (activeStepIsEmpty()) {
                <div class="dropzone" [class.dropzone--over]="stepDragOver()">
                  <p class="dropzone__title">{{ 'GENERAL_TAB.DRAG_AND_DROP' | translate }}</p>
                  <app-button
                    variant="primary"
                    color="amarante"
                    size="small"
                    [label]="'GENERAL_TAB.ADD_FILE' | translate"
                    [addIconLeft]="true"
                    (clicked)="openUploadPopup()">
                    <img slot="icon-left" src="assets/icon/new_icon/add_circle.svg" alt="" />
                  </app-button>
                </div>
              } @else {
                <div class="detail__list" [class.detail__list--faded]="stepDragOver()">
                  <div class="select-all">
                    <app-checkbox
                      size="small"
                      [label]="(isAllSelected(etape.workflowEtapeInstanceId) ? 'GENERAL_TAB.UNSELECT_ALL' : 'GENERAL_TAB.SELECT_ALL') | translate"
                      [ngModel]="isAllSelected(etape.workflowEtapeInstanceId)"
                      (changed)="toggleSelectAll(etape.workflowEtapeInstanceId, $event)" />
                  </div>

                  @for (sousDossier of dossier.sousDossiers; track sousDossier.dossierId) {
                    <div
                      class="folder-card"
                      [class.folder-card--expanded]="isSubFolderExpanded(sousDossier.dossierId)"
                      [class.folder-card--drag-over]="subFolderDragOver() === sousDossier.dossierId"
                      (dragenter)="onSubFolderDragEnter($event, sousDossier.dossierId)"
                      (dragover)="onSubFolderDragOver($event)"
                      (dragleave)="onSubFolderDragLeave($event, sousDossier.dossierId)"
                      (drop)="onSubFolderDrop($event, etape.workflowEtapeInstanceId, sousDossier.dossierId)">
                      <div class="folder-card__header" (click)="toggleSubFolder(sousDossier.dossierId)">
                        <span (click)="$event.stopPropagation()">
                          <app-checkbox
                            size="small"
                            [ariaLabel]="'GLOBAL.SELECT_ITEM' | translate: { name: sousDossier.nom }"
                            [ngModel]="isItemSelected('folder', sousDossier.dossierId, etape.workflowEtapeInstanceId)"
                            (changed)="toggleItemSelection('folder', sousDossier.dossierId, etape.workflowEtapeInstanceId, $event)" />
                        </span>
                        <img class="folder-card__icon" src="assets/icon/folder_icon.svg" alt="" />
                        <span class="folder-card__name" [title]="sousDossier.nom">{{ sousDossier.nom }}</span>
                        <span class="folder-card__count" [class.folder-card__count--muted]="sousDossier.fichiers.length === 0">
                          {{ sousDossier.fichiers.length }} {{ 'GENERAL_TAB.FILES' | translate }}
                        </span>
                        <span class="folder-card__actions" (click)="$event.stopPropagation()">
                          <app-button variant="tertiary" color="amarante" size="small" [addIconLeft]="true" [addLabel]="false"
                            [attr.title]="'FILE_EXPLORER.RENOMMER' | translate"
                            (clicked)="renameFolder(sousDossier, etape.workflowEtapeInstanceId)">
                            <img slot="icon-left" src="assets/icon/pencil.svg" alt="" />
                          </app-button>
                          <app-button variant="tertiary" color="semantic-red" size="small" [addIconLeft]="true" [addLabel]="false"
                            (clicked)="deleteFolder(sousDossier, etape.workflowEtapeInstanceId)">
                            <img slot="icon-left" src="assets/icon/delete.svg" alt="" />
                          </app-button>
                        </span>
                        <img class="folder-card__chevron"
                          [src]="isSubFolderExpanded(sousDossier.dossierId) ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'" alt="" />
                      </div>

                      @if (isSubFolderExpanded(sousDossier.dossierId) && sousDossier.fichiers.length > 0) {
                        <div class="folder-card__files">
                          @for (fichier of sousDossier.fichiers; track fichier.fichierId) {
                            <ng-container
                              [ngTemplateOutlet]="fileRow"
                              [ngTemplateOutletContext]="{ $implicit: fichier, stepId: etape.workflowEtapeInstanceId }" />
                          }
                        </div>
                      }
                    </div>
                  }

                  @for (fichier of dossier.fichiers; track fichier.fichierId) {
                    <ng-container
                      [ngTemplateOutlet]="fileRow"
                      [ngTemplateOutletContext]="{ $implicit: fichier, stepId: etape.workflowEtapeInstanceId }" />
                  }
                </div>

                @if (stepDragOver()) {
                  <div class="drag-overlay">
                    <p class="drag-overlay__text">{{ 'GENERAL_TAB.DRAG_AND_DROP' | translate }}</p>
                  </div>
                }
              }
            } @else {
              <p class="blast-files__state">{{ 'GLOBAL.CHARGEMENT' | translate }}</p>
            }
          </div>
        </section>
      }
    </div>
  }
</div>

<ng-template #fileRow let-fichier let-stepId="stepId">
  <div class="file-row">
    <app-checkbox
      size="small"
      [ariaLabel]="'GLOBAL.SELECT_ITEM' | translate: { name: fichier.nom }"
      [ngModel]="isItemSelected('file', fichier.fichierId, stepId)"
      (changed)="toggleItemSelection('file', fichier.fichierId, stepId, $event)" />
    <img class="file-row__icon" src="assets/icon/files.svg" alt="" />
    <span
      class="file-row__name"
      [class.file-row__name--clickable]="canPreview(fichier)"
      [title]="fichier.nom"
      (click)="canPreview(fichier) && openFileInNewWindow(fichier, $event, stepId)">
      {{ fichier.nom }}
    </span>
    <span class="file-row__meta" [title]="getFileTooltip(fichier)">
      {{ getFileExtension(fichier.nom) | uppercase }} - {{ formatFileSize(fichier.taille) }} - {{ formatFileDate(fichier.dateCreation) }}
    </span>
    <span class="file-row__actions">
      @if (canPreview(fichier)) {
        <app-button variant="tertiary" color="amarante" size="small" [addIconLeft]="true" [addLabel]="false"
          (clicked)="openFileInNewWindow(fichier, $event, stepId)">
          <img slot="icon-left" src="assets/icon/Visible.svg" alt="" />
        </app-button>
      }
      <app-button variant="secondary" color="amarante" size="small" [addIconLeft]="true" [addLabel]="false"
        (clicked)="downloadFile(fichier, stepId)">
        <img slot="icon-left" src="assets/icon/download.svg" alt="" />
      </app-button>
      <app-button variant="tertiary" color="amarante" size="small" [addIconLeft]="true" [addLabel]="false"
        (clicked)="renameFile(fichier, stepId)">
        <img slot="icon-left" src="assets/icon/pencil.svg" alt="" />
      </app-button>
      <app-button variant="tertiary" color="semantic-red" size="small" [addIconLeft]="true" [addLabel]="false"
        (clicked)="deleteFile(fichier, stepId)">
        <img slot="icon-left" src="assets/icon/delete.svg" alt="" />
      </app-button>
    </span>
  </div>
</ng-template>

<input #fileInput type="file" multiple hidden accept="*/*" (change)="onFileInputChange($event)" />

<app-popup
  class="upload-popup"
  [title]="'GENERAL_TAB.ADD_FILES' | translate"
  [isOpen]="showUploadPopup()"
  size="xlarge"
  variant="secondary"
  color="mint"
  (closed)="cancelUpload()">
  <div
    class="upload-dropzone step-drag-zone"
    [class.upload-dropzone--over]="uploadDragOver()"
    (dragover)="onUploadDragOver($event)"
    (dragleave)="onUploadDragLeave($event)"
    (drop)="onUploadDrop($event)"
    (click)="triggerFileInput()">
    <p class="upload-dropzone__title">{{ 'GENERAL_TAB.DRAG_AND_DROP' | translate }}</p>
    <p class="upload-dropzone__hint">{{ 'GENERAL_TAB.CLICK_TO_SELECT' | translate }}</p>
  </div>

  @if (uploadFiles().length > 0) {
    <div class="upload-list__header">
      <span class="upload-list__title">{{ 'GENERAL_TAB.SELECTED_FILES' | translate }} ({{ uploadFiles().length }})</span>
      <app-checkbox
        size="small"
        [label]="'GENERAL_TAB.SELECT_ALL' | translate"
        [ngModel]="areAllUploadFilesSelected()"
        (changed)="toggleAllUploadFiles($event)" />
    </div>

    <div class="upload-list">
      @for (file of uploadFiles(); track $index; let i = $index) {
        <div class="upload-item">
          <app-checkbox size="small" [ariaLabel]="'GLOBAL.SELECT_ITEM' | translate: { name: file.name }" [ngModel]="uploadSelected().has(i)" (changed)="toggleUploadFile(i, $event)" />
          <img class="upload-item__icon" src="assets/icon/files.svg" alt="" />
          <span class="upload-item__info">
            <span class="upload-item__name" [title]="file.name">{{ file.name }}</span>
            <span class="upload-item__size">{{ formatFileSize(file.size) }}</span>
          </span>
          <select
            class="native-select"
            [disabled]="uploadSelected().has(i)"
            (change)="onFileDestinationChange(i, $any($event.target).value)">
            @if (uploadSelected().has(i)) {
              <option selected disabled>{{ 'GENERAL_TAB.USE_GLOBAL_SELECTION' | translate }}</option>
            } @else {
              @for (option of folderOptions(); track option.id) {
                <option [value]="option.id" [selected]="(uploadDestinations()[i] ?? rootFolderId) === option.id">{{ option.label }}</option>
              }
            }
          </select>
          <app-button variant="tertiary" color="semantic-red" size="small" [addIconLeft]="true" [addLabel]="false"
            (clicked)="removeUploadFile(i)">
            <img slot="icon-left" src="assets/icon/delete.svg" alt="" />
          </app-button>
        </div>
      }
    </div>

    <p class="upload-total">{{ 'GENERAL_TAB.TOTAL_SIZE' | translate }} : {{ formatFileSize(uploadTotalSize()) }}</p>

    @if (uploadHasDuplicates()) {
      <p class="upload-warning">{{ 'GENERAL_TAB.DUPLICATE_FILE_WARNING' | translate }}</p>
    }

    @if (uploadSelected().size > 0) {
      <div class="upload-destination">
        <span class="upload-destination__label">
          {{ 'GENERAL_TAB.FOLDER_FOR_ALL_SELECTED_FILES' | translate }} ({{ uploadSelected().size }} {{ 'GENERAL_TAB.SELECTED' | translate }})
        </span>
        <app-select
          size="small"
          [options]="folderOptions()"
          [ngModel]="uploadGlobalFolderId() ?? rootFolderId"
          (selectionChange)="onGlobalFolderSelected($event)" />
      </div>
    }
  } @else {
    <p class="upload-empty">{{ 'GENERAL_TAB.NO_FILES_SELECTED' | translate }}</p>
  }

  <ng-container slot="footer">
    <app-button variant="secondary" color="amarante" [label]="'GENERAL_TAB.CANCEL' | translate" (clicked)="cancelUpload()" />
    @if (uploadFiles().length > 0) {
      <app-button
        variant="primary"
        color="amarante"
        [label]="('GENERAL_TAB.UPLOAD_ALL' | translate) + ' ' + uploadFiles().length + ' ' + ('GENERAL_TAB.FILES' | translate)"
        (clicked)="confirmUpload()" />
    }
  </ng-container>
</app-popup>

<app-popup
  [title]="'FILE_EXPLORER.AJOUT_DOSSIER' | translate"
  [isOpen]="showAddFolderPopup()"
  size="small"
  variant="secondary"
  color="mint"
  (closed)="showAddFolderPopup.set(false)">
  <app-input
    [placeholder]="'GLOBAL.NOM' | translate"
    [ngModel]="newFolderName()"
    (ngModelChange)="newFolderName.set($event)"
    (keyup.enter)="confirmAddFolder()" />
  @if (folderNameError()) {
    <p class="popup-error" [innerHTML]="'FILE_EXPLORER.CARACTERES_SPECIAUX' | translate"></p>
  }
  @if (folderNameRequired()) {
    <p class="popup-error">{{ 'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</p>
  }
  @if (folderNameExists()) {
    <p class="popup-error">{{ 'FILE_EXPLORER.DOSSIER_EXISTANT' | translate }}</p>
  }
  <ng-container slot="footer">
    <app-button variant="secondary" color="amarante" [label]="'GLOBAL.FERMER' | translate" (clicked)="showAddFolderPopup.set(false)" />
    <app-button variant="primary" color="amarante" [label]="'GLOBAL.VALIDER' | translate" (clicked)="confirmAddFolder()" />
  </ng-container>
</app-popup>

<app-popup
  [title]="'FILE_EXPLORER.RENOMMER' | translate"
  [isOpen]="showRenamePopup()"
  size="small"
  variant="secondary"
  color="mint"
  (closed)="closeRename()">
  <app-input
    [placeholder]="'GLOBAL.NOM' | translate"
    [ngModel]="newName()"
    (ngModelChange)="newName.set($event)"
    (keyup.enter)="confirmRename()" />
  @if (renameNameError()) {
    <p class="popup-error" [innerHTML]="'FILE_EXPLORER.CARACTERES_SPECIAUX' | translate"></p>
  }
  @if (renameNameRequired()) {
    <p class="popup-error">{{ 'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</p>
  }
  <ng-container slot="footer">
    <app-button variant="secondary" color="amarante" [label]="'GLOBAL.FERMER' | translate" (clicked)="closeRename()" />
    <app-button variant="primary" color="amarante" [label]="'GLOBAL.VALIDER' | translate" (clicked)="confirmRename()" />
  </ng-container>
</app-popup>

<app-popup
  [title]="'GLOBAL.CONFIRMATION_SUPPRESSION' | translate"
  [isOpen]="showDeletePopup()"
  size="small"
  variant="secondary"
  color="semantic-red"
  (closed)="closeDelete()">
  <p class="popup-text">{{ 'GLOBAL.CONFIRMATION_SUPPRESSION' | translate }}</p>
  <ng-container slot="footer">
    <app-button variant="secondary" color="amarante" [label]="'GLOBAL.NON' | translate" (clicked)="closeDelete()" />
    <app-button variant="primary" color="semantic-red" [label]="'GLOBAL.OUI' | translate" (clicked)="confirmDelete()" />
  </ng-container>
</app-popup>

<app-popup
  [title]="'FILE_EXPLORER.TRANSFERT' | translate"
  [isOpen]="showUploadProgress()"
  size="small"
  variant="secondary"
  color="mint"
  (closed)="showUploadProgress.set(false)">
  <div class="progress">
    <div class="progress__bar">
      <div class="progress__fill" [style.width.%]="uploadProgress()"></div>
    </div>
    <span class="progress__value">{{ 'FILE_EXPLORER.AVANCEMENT' | translate }} : {{ uploadProgress() }}%</span>
  </div>
</app-popup>

<app-popup
  [title]="'FILE_EXPLORER.TELECHARGEMENT' | translate"
  [isOpen]="downloadInProgress()"
  size="small"
  variant="secondary"
  color="mint"
  (closed)="downloadInProgress.set(false)">
  <p class="popup-text">{{ 'FILE_EXPLORER.PREPARATION_TELECHARGEMENT' | translate }}</p>
</app-popup>

<app-popup
  [title]="'FILE_EXPLORER.RENOMMER' | translate"
  [isOpen]="showSyncErrorPopup()"
  size="small"
  variant="secondary"
  color="semantic-red"
  (closed)="showSyncErrorPopup.set(false)">
  <p class="popup-text">{{ 'FILE_EXPLORER.FICHIER_RENOMME_SUPPR' | translate }}</p>
  <ng-container slot="footer">
    <app-button variant="primary" color="amarante" [label]="'GLOBAL.OK' | translate" (clicked)="showSyncErrorPopup.set(false)" />
  </ng-container>
</app-popup>
